module.exports = __webpack_public_path__ + "img/auditImg.d3f32e2c.png";